<template>
    <!-- <div class="d-flex align-center flex-column transparent"> -->
        <v-card style="margin-top: 10px; margin-bottom: 10px" width="1200px" min-height="500px">
           
            <v-card-title>
                <h4>Download แบบฟอร์มหุ้นกู้</h4>
            </v-card-title>
            <v-card-text>
            <!-- <v-col>
                <v-sheet rounded="lg"> -->
                    <form>
                        <template>
                        <ul id="example-1">
                                <li v-for="(group,index1) in ListGroup" :key="index1">
                                     {{ group.groupName }}                                    
                                     <v-list v-for="(listname,index) in group.formList" :key="index">
                                        <a  @click="Downloadx(listname.fileName)"> {{ listname.formName }}</a>
                                    </v-list>
                                </li>
                          </ul>
                       
                         
                        </template>
                         <v-row style="height:50px;margin-top:20px;margin-right:20px" height: justify="end"><a href="/">กลับหน้าแรก</a></v-row>
                         
                    </form>
                <!-- </v-sheet>
            </v-col> -->
            </v-card-text>
        </v-card>
    <!-- </div> -->
</template>
<script>
export default {
  data: () => ({
    ListGroup: [],
  }),
  async created() {
    this.$store
      .dispatch("MDownload50/funcGetListDownload")
      .then((resp) => {
        if (resp != null) {
          this.ListGroup = resp;
        }
      })
      .catch(() => {
        this.isShowError = true;
      });

    /* const response = await axios.get(this.urlapi+'GetListDownload');
        //https://cmk-reg.uat.krungthai/web/uat/api/
         this.ListGroup = response.data;*/
  },
  methods: {
    Downloadx(fileName) {
      const PostDownload = {
        Filename: fileName,
      };
      console.log(PostDownload);
      this.$store
        .dispatch("MDownload50/funcPostDownloadForm", PostDownload)
        .then((resp) => {
          if (resp != null) {
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            if (resp.Formload != "") {
              /*alert(response.data);
                                alert(response.data.Filename);*/
              var byteCharacters = atob(resp.Formload);
              var byteNumbers = new Array(byteCharacters.length);
              for (var i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
              }
              var byteArray = new Uint8Array(byteNumbers);
              let blob = new Blob([byteArray], { type: "application/pdf" }),
                url = window.URL.createObjectURL(blob);

              this.overlay = false;
              a.href = url;
              a.download = fileName;
              a.click();
              window.URL.revokeObjectURL(url);
            }
          }
        })
        .catch(() => {
          this.isShowError = true;
        });

      /* const _api = axios.post(this.urlapi + 'PostDownloadForm', PostDownload, "", { responseType: 'arraybuffer' });
            _api
                .then(response => {
                    
                   var a = document.createElement("a");
                            document.body.appendChild(a);
                            a.style = "display: none";
                    if (response.data.Formload != "") {
                      
                        var byteCharacters = atob(response.data.Formload);
                        var byteNumbers = new Array(byteCharacters.length);
                        for (var i = 0; i < byteCharacters.length; i++) {
                            byteNumbers[i] = byteCharacters.charCodeAt(i);
                        }
                        var byteArray = new Uint8Array(byteNumbers);
                        let blob = new Blob([byteArray], { type: "application/pdf" }),
                            url = window.URL.createObjectURL(blob);
                          
                        this.overlay = false;
                         a.href = url;
                         a.download = fileName;
                         a.click();
                         window.URL.revokeObjectURL(url);
                    } else {
                       //this.dialogText = "ไม่พบข้อมูลทวิ50 ที่ร้องขอ";
                        ///this.dialog = true
                       // this.overlay = false;
                    }
                    //let blob = new Blob([response.data.ImgByte2], { type: 'application/pdf' }),
                     //   url = window.URL.createObjectURL(blob)
                    //window.open(url) // Mostly the same, I was just experimenting with different approaches, tried link.click, iframe and other solutions
                })*/
    },
  },
};
</script>